/**
 * Canonical serialisation for sync payloads (ADR-006): stable key order so
 * the SHA-256 content hash of an aggregate is identical however the object
 * was assembled. The queue stores the exact canonical bytes at enqueue time -
 * later app versions never re-serialise history.
 */
export function canonicalJson(value) {
    if (value === null || typeof value !== 'object')
        return JSON.stringify(value);
    if (Array.isArray(value))
        return `[${value.map((v) => canonicalJson(v)).join(',')}]`;
    const keys = Object.keys(value).sort();
    const body = keys
        .filter((k) => value[k] !== undefined)
        .map((k) => `${JSON.stringify(k)}:${canonicalJson(value[k])}`)
        .join(',');
    return `{${body}}`;
}
/** SHA-256 hex over UTF-8 text. WebCrypto exists in Node ≥ 20 and WebViews. */
export async function sha256Hex(text) {
    const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
//# sourceMappingURL=canonical.js.map